module.exports = __webpack_public_path__ + "9ef07ea6ee6d06f4fd48a548168b69aa.woff2";